// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__KPe2y","container":"style_container__9RmDA","frame":"style_frame__43sef","content":"style_content__WwUCy","crop":"style_crop__wCeoe"};